import { Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { Post, Post1 } from 'components/blog';
import { post1 } from './data';


type BlogPostProps = {
    Post1: Post1;
};

// const formatTitleForURL = (title?: string) => (title ? title.toLowerCase().replace(/\s+/g, '-') : '');
const formatTitleForURL = (title?: string) =>
    title
        ? title
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '') // remove : , ? ! etc.
            .replace(/\s+/g, '-')        // convert spaces to hyphen
            .trim()
        : '';


const BlogPost2 = ({ Post1 }: BlogPostProps) => {
    // const blogUrl = Post1.title ? `/crm/blog/post/${formatTitleForURL(Post1.title)}` : "#";
    const blogUrl = Post1.title ? `/blog/${formatTitleForURL(Post1.title)}` : "#";
    console.log('blogUrl', blogUrl);

    return (
        <>
            <div>
                <div className='border border-dark  mt-2 mb-2 rounded'>
                    <img src={Post1.image} alt={Post1.title || "sales blog"} className="img-fluid d-block shadow rounded" style={{ width: "100%", height: "250px", objectFit: "cover" }} />
                </div>
                <div className="mt-3">
                    <p>
                        {new Intl.DateTimeFormat("en-US", {
                            day: "numeric",
                            month: "long",
                            year: "numeric"
                        }).format(new Date(Post1.createdOn))}
                    </p>

                    <Link to="#">
                        <Badge bg="" className={classNames('badge-soft-orange mb-1')}>
                            {Post1.tag}
                        </Badge>
                    </Link>
                </div>

                <h4 className="fw-semibold mt-1">

                    <Link to={blogUrl} state={{ id: Post1.id }} className="">
                        {Post1.title}
                    </Link>
                </h4>

                {/* <p className="text-muted mb-5">
                    {Post1.description}{' '}
                    <Link to={blogUrl} state={{ id: Post1.id }} className="text-primary">
                        read more
                    </Link>
                </p> */}
                <p className="text-muted mb-5">
                    {Post1.description}...  <br />
                    <Link
                        to={blogUrl}
                        state={{ id: Post1.id }}
                        style={{
                            backgroundColor: '#5c6f88',
                            color: '#fff',
                            padding: '6px 18px',
                            borderRadius: '6px',
                            fontWeight: 600,
                            textDecoration: 'none',
                            display: 'inline-block',
                            cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                            (e.currentTarget as HTMLElement).style.backgroundColor = '#4d6078';
                        }}
                        onMouseLeave={(e) => {
                            (e.currentTarget as HTMLElement).style.backgroundColor = '#5c6f88';
                        }}
                    >
                        Read More
                    </Link>
                </p>


            </div>
        </>
    );
};

export default BlogPost2;
